export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56')
];

export const server_loads = [9,2,3,4,7];

export const dictionary = {
		"/(shop)": [51,[9]],
		"/(shop)/about": [52,[10]],
		"/(auth)/activate": [12,[2]],
		"/(auth)/apply": [13,[2]],
		"/(business)/business/business-details": [19,[3]],
		"/(business)/business/payment-details": [~20,[3]],
		"/(payment)/card-payment": [48,[8]],
		"/(shop)/categories": [53,[9]],
		"/(shop)/contact": [54,[11]],
		"/(dashboard)/dashboard": [~21,[4]],
		"/(dashboard)/dashboard/accounts": [22,[4]],
		"/(dashboard)/dashboard/analytics": [23,[4]],
		"/(dashboard)/dashboard/assistant": [24,[4]],
		"/(dashboard)/dashboard/blogs": [25,[4]],
		"/(dashboard)/dashboard/blogs/blogdetails": [~26,[4]],
		"/(dashboard)/dashboard/brands": [27,[4]],
		"/(dashboard)/dashboard/brands/add-brand": [28,[4]],
		"/(dashboard)/dashboard/categories": [29,[4]],
		"/(dashboard)/dashboard/categories/add-category": [30,[4]],
		"/(dashboard)/dashboard/contacts": [31,[4]],
		"/(dashboard)/dashboard/customers": [32,[4]],
		"/(dashboard)/dashboard/customize-website": [33,[4]],
		"/(dashboard)/dashboard/invoice": [34,[4]],
		"/(dashboard)/dashboard/logout": [~35,[4]],
		"/(dashboard)/dashboard/orders": [36,[4]],
		"/(dashboard)/dashboard/orders/quotation": [38,[4]],
		"/(dashboard)/dashboard/orders/quotation/[id]": [39,[4]],
		"/(dashboard)/dashboard/orders/[id]": [37,[4]],
		"/(dashboard)/dashboard/products": [40,[4]],
		"/(dashboard)/dashboard/products/add-product-filters": [42,[4]],
		"/(dashboard)/dashboard/products/add-product": [41,[4]],
		"/(dashboard)/dashboard/settings": [43,[4,5]],
		"/(dashboard)/dashboard/subscription": [44,[4]],
		"/(auth)/ewf": [~14,[2]],
		"/(auth)/forgot-password": [15,[2]],
		"/(auth)/login": [16,[2]],
		"/(payment)/mobile-payment": [49,[8]],
		"/(payment)/payment-method": [50,[8]],
		"/(home)/privacy-policy": [45,[6]],
		"/(shop)/products": [55,[9]],
		"/(shop)/products/[slug]": [56,[9]],
		"/(auth)/reset-password": [17,[2]],
		"/(auth)/sign-up": [18,[2]],
		"/(home)/terms-and-conditions": [46,[6]],
		"/(home)/uzakitu-premium": [47,[7]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';